import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';

const menuGroups = [
  {
    title: 'Overview',
    items: [
      { path: '/dashboard', label: 'Dashboard', short: 'DB' }
    ]
  },
  {
    title: 'Orders',
    items: [
      { path: '/payin', label: 'PayIN', short: 'IN' },
      { path: '/payout', label: 'PayOUT', short: 'OUT' }
    ]
  },
  {
    title: 'Assets',
    items: [
      { path: '/requisites', label: 'Requisites', short: 'RQ' },
      { path: '/devices', label: 'Devices', short: 'DV' },
      { path: '/gateways', label: 'Gateways', short: 'GW' },
      { path: '/prices', label: 'Prices', short: 'PR' }
    ]
  },
  {
    title: 'Control',
    items: [
      { path: '/balance-operations', label: 'Balance Operations', short: 'BO' },
      { path: '/traders', label: 'Traders', short: 'TR' },
      { path: '/banks', label: 'Banks', short: 'BK' },
      { path: '/currencies', label: 'Currencies', short: 'FX' },
      { path: '/messages', label: 'Messages', short: 'MS' },
      { path: '/transactions', label: 'Transactions', short: 'TX' },
      { path: '/requests', label: 'Requests', short: 'RQ' }
    ]
  }
];

const roleLabels = {
  admin: 'Administrator',
  support: 'Support'
};

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const visibleMenuGroups = user?.role === 'support'
    ? menuGroups.filter((group) => group.title === 'Orders')
    : menuGroups;

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle('sidebar-open', isOpen);

    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [isOpen]);

  const handleLogout = () => {
    signOut();
    navigate('/login');
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
      >
        {isOpen ? 'Close' : 'Menu'}
      </button>
      {isOpen && <div className="sidebar-overlay active" onClick={closeSidebar} />}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img
            className="sidebar-logo"
            src="/nadal-pay-logo.png?v=20261027"
            alt="Nadal Pay"
          />
        </div>

        {user && (
          <div className="sidebar-user-section">
            <div className="sidebar-user-card">
              <div>
                <div className="sidebar-user-role">
                  {roleLabels[user.role] || user.role || 'User'}
                </div>
                <div className="sidebar-user-name">{user.name || user.login}</div>
              </div>
            </div>
          </div>
        )}

        <nav className="sidebar-nav">
          {visibleMenuGroups.map((group) => (
            <div key={group.title} className="sidebar-group">
              <div className="sidebar-group-title">{group.title}</div>
              <ul className="sidebar-menu">
                {group.items.map((item) => (
                  <li key={item.path} className="sidebar-menu-item">
                    <Link
                      to={item.path}
                      className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
                      onClick={closeSidebar}
                    >
                      <span className="sidebar-label">{item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="sidebar-logout-button">
            Sign Out
          </button>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
